import React, { useEffect, useRef } from "react";

export default function SdxInput({ value, onChange, validate, ...props }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.value = value ?? "";
  }, [value]);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handler = (e) => {
      const val = e.target.value;
      onChange?.(val);

      if (validate) {
        el.validationMessage = validate(val);
      }
    };

    el.addEventListener("input", handler);
    return () => el.removeEventListener("input", handler);
  }, [onChange]);

  return <sdx-input ref={ref} {...props} />;
}
